import css from "./Spinner.module.css";

export default function Spinner() {
	return <span className={css.loader}></span>;
}
